<script>
	import QuantitySelect from './QuantitySelect.svelte'
	import LineItemPrice from './LineItemPrice.svelte'
	import SubtleButton from './SubtleButton.svelte'
	import Subtotal from './Subtotal.svelte'

	export let api, key = null, item
</script>

<div class="controls">
	<div class="top">
		<LineItemPrice {item} />

		{#if item?.product.type !== `donation` && item?.product.type !== `trex_gift_card`}
			{#if item.lineitem_group_id}
				<div class="readonly-quantity">&times; {item.quantity}</div>
			{:else}
				<QuantitySelect
					max={item.max_quantity}
					bind:value="{item.quantity}"
					on:change="{() => api(`/item/update`, { cart_item_key: key, quantity: item.quantity })}" />
			{/if}
		{/if}

		<div class="subtotal">
			<Subtotal subtotal={item.line_subtotal} />
		</div>
	</div>
	{#if !item?.lineitem_group_id}
		<div class="bottom">
			<SubtleButton on:click="{() => api(`/item/remove`, { cart_item_key: key })}">Remove</SubtleButton>
		</div>
	{/if}
</div>

<style>
	.controls {
		display: flex;
		flex: 0 0 auto;
		flex-direction: column;
		justify-content: space-between;
	}
	.controls .top, .controls .bottom {
		display: flex;
		flex: 0 0 auto;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
		margin: 10px;
		gap: 20px;
	}

	.readonly-quantity {
		line-height: 1;
	}

	@media (max-width: 600px) {
		.controls .top, .controls .bottom {
			gap: 5px;
			margin: 0;
			flex-direction: column;
			align-items: end;
		}
		.subtotal {
			display:  none;
		}
	}
</style>
